// extracted by mini-css-extract-plugin
export var marginNegative = "_5g-5 _5g-3 _5g-1";
export var marginPositive = "_5g-4 _5g-3 _5g-1";
export var modalContent = "_5g-6";
export var samplesTable = "_5g-8";
export var samplesTableContainer = "_5g-7";
export var statBox = "_5g-a";
export var tableCell = "_5g-1";
export var tableCellCenter = "_5g-2 _5g-1";
export var tableCellRight = "_5g-3 _5g-1";
export var tableHeader = "_5g-0";
export var trackingNumber = "_5g-9";